import { MODAL_NAME } from 'utils';
import { useAlertContext, useAuthContext, useModalContext } from 'context';
import { useGetCurrentUserQuery } from 'graphql/generated';
import { useTranslation } from 'next-i18next';

export const usePhoneVerify = () => {
  const { onOpenModal } = useModalContext();
  const { onOpenAlert } = useAlertContext();
  const { isAuth } = useAuthContext();
  const { t } = useTranslation();

  const { data: currentUserData } = useGetCurrentUserQuery({
    skip: !isAuth,
  });

  const phoneNumber = currentUserData?.getCurrentUser.phoneNumber;

  const phoneVerify = (ph?: string) => {
    if (!phoneNumber && !ph) return;
    if (currentUserData?.getCurrentUser.phoneIsVerified) {
      return onOpenAlert({
        subTitle: t`app.error.your_phone_is_authorized`,
      });
    }

    onOpenModal(MODAL_NAME.phoneVerification, { phoneNumber });
  };
  return { phoneVerify };
};
